import { useMutation } from 'react-query';

import { downloadCardAssociatedDocument as mutationFn } from 'api/endPoints/downloadCardAssociatedDocument';

export const useMutationDownloadExternalDocument = () => {
    return useMutation<unknown, QueryError, QueryParams>((params) => mutationFn(params));
};

export interface QueryParams {
    documentId: number;
    fileName: string;
}
